import { render } from "./TgLogin.vue?vue&type=template&id=41794f35&scoped=true"
import script from "./TgLogin.vue?vue&type=script&lang=js"
export * from "./TgLogin.vue?vue&type=script&lang=js"

import "./TgLogin.vue?vue&type=style&index=0&id=41794f35&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41794f35"]])

export default __exports__